// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clickable {
	cursor: pointer;
}

.mosquito-container-wrap {
	background: var(--www-color-float-bg2);
	border-radius: 0.7rem;
	color: var(--primary-color1);
	margin-bottom: 1rem;
	cursor: default;
	/* height: 96px; */
}

.mosquito-container {
	display: flex;
	align-self: stretch;
	padding: 1rem;
	padding: 0.5rem;
	align-items: center;
	flex-grow: 1;
}
.mosquito-container span {
	font-weight: bold;
}
.mosquito-container .icons {
	display: flex;
	padding: 0;
	padding-top: 0.5rem;
	margin-bottom: 0;
}
.mosquito-container .icons a {
	height: 42px;
}
.mosquito-container .icons img {
	width: 32px;
	margin: 0.5rem 0.5rem;
}
.mosquito-text {
	display: flex;
	flex-direction: column;
	font-size: 1.4rem;
}
.mosquito-text strong {
	font-family: "Inter-Bold", sans-serif;
	font-weight: bold;
}
.mosquito-text p {
	padding: 0.5rem 0 0 1rem;
}
.mosquito-text-full {
	padding: 0.5rem;
	padding-bottom: 1rem;
}
.mosquito-text-full p {
	padding: 0;
	padding-bottom: 0.5rem;
}
.mosquito-text-full p:last-child {
	padding: 0;
}
.mosquito-text-full p:first-child {
	padding-right: 24px;
}
.mosquito-text-full ul {
	padding: 0.5rem 0 0.5rem 0;
}
.mosquito-text-full li {
	list-style: inside;
	padding: 0 0 0.5rem 1rem;
}
.mosquito-heading {
	text-align: center;
	color: var(--primary-color2);
	padding: 0.5rem;
}
.mosquito-heading h3 {
	padding: 0.2rem;
	font-size: 1.2rem;
	color: var(--primary-color1);
}
.mosquito-heading h1 {
	padding: 0.1rem;
	font-size: 1.6rem;
}
.mosquito-heading p {
	font-size: 1rem;
	color: var(--primary-color1);
	font-weight: 300;
}
@media (min-width: 500px) {
	.mosquito-heading h3 {
		padding: 0.1rem;
		font-size: 1.4rem;
	}
	.mosquito-heading h1 {
		padding: 0.1rem;
		font-size: 1.6rem;
	}
}
.mosquito-heading p {
	font-size: 1.2rem;
}

/*
@media (min-width: 500px) and (max-height:415px) {

  .mosquito-heading h3 {
    padding: 0.1rem;
    font-size: 1.4rem;
  }
  .mosquito-heading h1 {
    padding: 0.1rem;
    font-size: 1.6rem;
  }

.mosquito-heading p {
  font-size: 1.2rem;
}
.mosquito-container {
  background: var(--www-color-float-bg2);
align-self:stretch;
  border-radius: 0.7rem;
  margin: 0rem 0.5rem;

}
}
*/
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/MosquitoInfo/FloatPanelMosquitoInfo.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB;;AAEA;CACC,sCAAsC;CACtC,qBAAqB;CACrB,4BAA4B;CAC5B,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,UAAU;CACV,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;CACX,qBAAqB;AACtB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB;AAClB;AACA;CACC,qCAAqC;CACrC,iBAAiB;AAClB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,eAAe;CACf,oBAAoB;AACrB;AACA;CACC,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,UAAU;AACX;AACA;CACC,mBAAmB;AACpB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,kBAAkB;CAClB,wBAAwB;AACzB;AACA;CACC,kBAAkB;CAClB,4BAA4B;CAC5B,eAAe;AAChB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,4BAA4B;AAC7B;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,4BAA4B;CAC5B,gBAAgB;AACjB;AACA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;AACA;CACC,iBAAiB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;CAuBC","sourcesContent":[".clickable {\n\tcursor: pointer;\n}\n\n.mosquito-container-wrap {\n\tbackground: var(--www-color-float-bg2);\n\tborder-radius: 0.7rem;\n\tcolor: var(--primary-color1);\n\tmargin-bottom: 1rem;\n\tcursor: default;\n\t/* height: 96px; */\n}\n\n.mosquito-container {\n\tdisplay: flex;\n\talign-self: stretch;\n\tpadding: 1rem;\n\tpadding: 0.5rem;\n\talign-items: center;\n\tflex-grow: 1;\n}\n.mosquito-container span {\n\tfont-weight: bold;\n}\n.mosquito-container .icons {\n\tdisplay: flex;\n\tpadding: 0;\n\tpadding-top: 0.5rem;\n\tmargin-bottom: 0;\n}\n.mosquito-container .icons a {\n\theight: 42px;\n}\n.mosquito-container .icons img {\n\twidth: 32px;\n\tmargin: 0.5rem 0.5rem;\n}\n.mosquito-text {\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 1.4rem;\n}\n.mosquito-text strong {\n\tfont-family: \"Inter-Bold\", sans-serif;\n\tfont-weight: bold;\n}\n.mosquito-text p {\n\tpadding: 0.5rem 0 0 1rem;\n}\n.mosquito-text-full {\n\tpadding: 0.5rem;\n\tpadding-bottom: 1rem;\n}\n.mosquito-text-full p {\n\tpadding: 0;\n\tpadding-bottom: 0.5rem;\n}\n.mosquito-text-full p:last-child {\n\tpadding: 0;\n}\n.mosquito-text-full p:first-child {\n\tpadding-right: 24px;\n}\n.mosquito-text-full ul {\n\tpadding: 0.5rem 0 0.5rem 0;\n}\n.mosquito-text-full li {\n\tlist-style: inside;\n\tpadding: 0 0 0.5rem 1rem;\n}\n.mosquito-heading {\n\ttext-align: center;\n\tcolor: var(--primary-color2);\n\tpadding: 0.5rem;\n}\n.mosquito-heading h3 {\n\tpadding: 0.2rem;\n\tfont-size: 1.2rem;\n\tcolor: var(--primary-color1);\n}\n.mosquito-heading h1 {\n\tpadding: 0.1rem;\n\tfont-size: 1.6rem;\n}\n.mosquito-heading p {\n\tfont-size: 1rem;\n\tcolor: var(--primary-color1);\n\tfont-weight: 300;\n}\n@media (min-width: 500px) {\n\t.mosquito-heading h3 {\n\t\tpadding: 0.1rem;\n\t\tfont-size: 1.4rem;\n\t}\n\t.mosquito-heading h1 {\n\t\tpadding: 0.1rem;\n\t\tfont-size: 1.6rem;\n\t}\n}\n.mosquito-heading p {\n\tfont-size: 1.2rem;\n}\n\n/*\n@media (min-width: 500px) and (max-height:415px) {\n\n  .mosquito-heading h3 {\n    padding: 0.1rem;\n    font-size: 1.4rem;\n  }\n  .mosquito-heading h1 {\n    padding: 0.1rem;\n    font-size: 1.6rem;\n  }\n\n.mosquito-heading p {\n  font-size: 1.2rem;\n}\n.mosquito-container {\n  background: var(--www-color-float-bg2);\nalign-self:stretch;\n  border-radius: 0.7rem;\n  margin: 0rem 0.5rem;\n\n}\n}\n*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
